module.exports = __webpack_public_path__ + "img/Flag_of_Liberia.e7026ad5.svg";